<template>
  <div class="difference-container" v-if="hasValueDiference">
    <h3>
      Diferença de valores({{ title }}) -
      {{ valueDiference > 0 ? 'Recebimento' : 'Despesa' }}
    </h3>
    <div class="form-group">
      <span class="label label-primary pull-right">
        Diferença: R$ {{ valueDiference.toFixed(2) }}
      </span>
    </div>
    <div class="difference-content">
      <div class="form-group col-md-6">
        <label>Descrição:</label>
        <input
          type="text"
          class="form-control"
          placeholder="Digite uma descrição"
          v-model="form.description"
        />
      </div>
      <div class="form-group col-md-6">
        <label>Label</label>
        <tags-input
          v-model="form.labels"
          placeholder="Insira uma label"
          :existing-tags="existentLabels"
          :typeahead="true"
          only-existing-tags
        ></tags-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    hasValueDiference: {
      default: false,
    },
    title: {
      default: '',
    },
    valueDiference: {
      default: '',
    },
    existentLabels: {
      default: [],
    },
  },
  data() {
    return {
      form: {
        description: 'Diferença de fechamento de caixa em ' + this.title,
        labels: [],
      },
    };
  },
};
</script>